import LanguagesService from 'api/languages/languagesService';
import { defineStore } from 'pinia';

export interface Language {
    id: number;
    lang: string;
    flag: string;
}

interface LanguagesState {
    languages: Language[];
}

export const useLanguagesStore = defineStore('languages', {
    state: (): LanguagesState => ({
        languages: [],
    }),
    actions: {
        fetchLanguages(): Promise<void> {
            return new Promise((resolve, reject) => {
                LanguagesService.getAllLanguages()
                    .then((response: Language[]) => {
                        this.languages = response;
                        resolve();
                    })
                    .catch((err: unknown) => {
                        reject(err);
                    });
            });
        },
    },
});
